import { Component, AfterViewInit, OnInit, Input, ElementRef, ViewChild } from '@angular/core';
import { ResizeEvent } from 'angular-resizable-element';
import { AuthService } from '../services/auth.service';
import * as io from 'socket.io-client';
import { Router } from '@angular/router';
import { GpsService } from '../services/gps.service';
import swal from 'sweetalert';
import * as jsts from 'jsts';
import { ToastrService } from 'ngx-toastr';
import { JwtHelperService } from '@auth0/angular-jwt';
// News impots
import * as moment from 'moment-timezone';
import { NgxSpinnerService } from 'ngx-spinner';
// News impots
import { ExcelService } from '../services/excel.service';
import * as leafletPip from '@mapbox/leaflet-pip';
// Operadores
import { OperadoresService } from '../services/operadores.service';
import * as modal from 'bootstrap';
import { NgSelectModule, NgOption } from '@ng-select/ng-select';
import { THIS_EXPR, ifStmt } from '@angular/compiler/src/output/output_ast';
// Usuarios & Restablecer contraseña
import { UsuariosService } from '../services/usuarios.service';
// Usuarios & Restablecer contraseña


declare let L: any;
declare let google: any;

@Component({
  selector: 'app-usuarios',
  templateUrl: './usuarios.component.html',
  styleUrls: ['./usuarios.component.css']
})
export class UsuariosComponent implements OnInit {
  subscribeUsuarios: any;
  @Input()
  public myInput: MouseEvent;

  constructor(
    private gps: GpsService,
    public auth: AuthService,
    private toastr: ToastrService,
    private router: Router,
    public jwtHelper: JwtHelperService,
    private spinner: NgxSpinnerService,
    private excelService: ExcelService,
    private operadoresService: OperadoresService,
    private usuarios: UsuariosService
  ) {
    moment.locale('es');
  }

  @ViewChild('info') info: ElementRef;

  // Variables para Soket
  private url = 'https://vigiliner.com.mx:1798';
  private socket;
  // Variables para Mapa
  public L: any;
  public google: any;
  public map;
  // Variables para GPS
  public markers = new L.FeatureGroup();
  public filtro = '';
  public style: object = {};
  public dispositivo = {};
  public dispositivoss = [];
  public divInformacion: object;
  public arrayOfKeys;
  public seteo_valoresseteo_valores = true;
  public datosXls: Array<any> = [];
  public respuestaParo: any;
  // Variables Reportes
  public formModel = {
    fechastart: moment().format('YYYY-MM-DD'),
    horastart: '00:00',
    fechaend: moment().format('YYYY-MM-DD'),
    horaend: moment().format('HH:mm')
  };
  public errorFechas = null;
  public divReportes: Array<any> = [];
  public selecTipo = 'todos';
  public markersRecorrido = [];
  public markersMovimiento = new L.layerGroup();
  public markersParadaMenor = new L.layerGroup();
  public markersParadaMayor = new L.layerGroup();
  public markersEstacionado = new L.layerGroup();
  public markersTodos = new L.layerGroup();
  public displayedmarkers;
  public polyline = new L.layerGroup();
  public polylineDecora = new L.layerGroup();
  // Variable para permiso de envio de comandos
  public comandos: boolean;
  // Variables Geocercas
  public drawMenu;
  public drawnItems;
  public geocercasList = [];
  // Variables para Operadores
  model: any = {};
  public listadoOperadores: Array<any> = [];
  public listadoAsignacion: Array<any> = [];
  public listadoIncidencias: Array<any> = [];
  historial: any = {};
  public unidadesXoperador: Array<any> = [];
  // Variables para Unidades
  public listadoUnidades: Array<any> = [];
  public servicioUnidades = {};
  public iconos: Array<any> = [];
  public colores: Array<any> = [];
  public historialUnidad = [];
  public listadoAsignaciones: Array<any> = [];
  public listadoServicios: Array<any> = [];
  // Variables para Usuarios
  public listadoUsuarios: Array<any> = [];
  public TodasUnidades: Array<any> = [];

  public contadorOfoto = true;
  public contadorPersonasE = 0;
  public contadorPersonasS = 0;


  /**
   * Se muestra todo lo que carga de entrada que son
   * Las unidades, operadores usuarios, validar si ha echo el cambio
   * inicial de contraseña, revisar que permisos tiene el usuario
   *
  **/
  ngOnInit() {
    //  Valida si tienes permisos para enviar comandos
    // tslint:disable-next-line:triple-equals
    if (this.jwtHelper.decodeToken(localStorage.getItem('access_token')).permisoID == 4) {
      this.comandos = false;
    } else {
      this.comandos = true;
    }
    document.oncontextmenu = function () { return false; };

    /**
      * Funcion para mostrar los usuarios y sus unidades asignadas
      * @param temporal Sirve para validar algunos campos
      * @param listadoUsuarios Se almacenan la informacion de los usuarios
    **/
    this.usuarios.listadoUsiarios().toPromise().then(result => {
      const temporal: Array<any> = [];
      result.forEach(element => {
        temporal.push({
          usuarioID: element.usuarioID,
          nombres: element.nombres,
          apellidos: element.apellidos,
          email: element.email,
          telefono: (element.telefono == null || element.telefono === '') ? 'Sin teléfono' : element.telefono,
          unidadesAlias: (element.unidadesAlias == null) ? 'No hay unidades asignadas' : element.unidadesAlias,
          unidadesID: (element.unidadesID == null) ? null : element.unidadesID.split(',')
        });
      });
      this.listadoUsuarios = temporal;
    },
      err => { this.auth.logout(); this.router.navigate(['login']); }
    );
    /**
      * Funcion para mostrar los usuarios y sus unidades asignadas
      * @param temporal Sirve para validar algunos campos
      * @param listadoOperadores Se almacenan la informacion de los operadores
    **/
    this.operadoresService.listadoOperadores().toPromise().then(result => {
        const temporal: Array<any> = [];
        result.forEach(element => {
          temporal.push({
            id: element.id,
            uid: element.uid,
            nombre: element.nombre,
            paterno: element.paterno,
            materno: element.materno,
            empleado: (element.empleado === null) ? ' --- ' : element.empleado,
            licencia: element.licencia
          });
        });
        this.listadoOperadores = temporal;
      },
      err => {
        this.auth.logout();
        this.router.navigate(['login']);
      }
    );
    /**
      * Funcion para mostrar los usuarios y sus unidades asignadas
      * @param temporal Sirve para validar algunos campos
      * @param dispositivo Se almacenan la informacion de las unidades
      * Su ultimo reporte, coordenadas, estado, etc.
      * @param dispositivoss sirve para mantener el orden de las unidades
      * @param markers Todas las unidades para mostrar en el mapa
    **/
    this.gps.getTodos().toPromise().then(result => {
      const temporal = this.listadoUnidades;
      this.dispositivoss = result;
      result.forEach(elemento => {
        // @ts-ignore
        this.dispositivo[elemento.imei] = elemento;
        let clase = '', faltan = 'Falta ';
        if (elemento.fechaServicio != null) {
          const dateNow = moment();
          const periodo = elemento.periodo.split('-');
          const fechaAvisar = moment(elemento.fechaServicio).subtract(periodo[0], periodo[1]).format('YYYY-MM-DD');
          if (dateNow.isBefore(fechaAvisar)) {
            clase = '';
          } else if (dateNow.isBetween(fechaAvisar, elemento.fechaServicio)) {
            clase = 'table-warning';
          } else if (dateNow.isSameOrAfter(fechaAvisar)) {
            clase = 'table-danger';
          }
          if (moment(elemento.fechaServicio, 'YYYY-MM-DD').diff(dateNow, 'years') > 0) {
            faltan += moment(elemento.fechaServicio, 'YYYY-MM-DD').diff(dateNow, 'years') + ' años.';
          }
          if (moment(elemento.fechaServicio, 'YYYY-MM-DD').diff(dateNow, 'months') > 0) {
            faltan += moment(elemento.fechaServicio, 'YYYY-MM-DD').diff(dateNow, 'months') + ' meses.';
          }
          if (moment(elemento.fechaServicio, 'YYYY-MM-DD').diff(dateNow, 'weeks') > 0) {
            faltan += moment(elemento.fechaServicio, 'YYYY-MM-DD').diff(dateNow, 'weeks') + ' semanas.';
          }
          if (moment(elemento.fechaServicio, 'YYYY-MM-DD').diff(dateNow, 'days') > 0) {
            faltan += moment(elemento.fechaServicio, 'YYYY-MM-DD').diff(dateNow, 'days') + ' días.';
          }
          if (moment(elemento.fechaServicio, 'YYYY-MM-DD').diff(dateNow, 'days') === 0) {
            faltan = 'Necesita servicio por fecha.';
          }
          if (moment(elemento.fechaServicio, 'YYYY-MM-DD').diff(dateNow, 'days') < 0) {
            faltan = 'Necesita servicio por fecha. Se ha pasado por ' +
              (moment(elemento.fechaServicio, 'YYYY-MM-DD').diff(dateNow, 'days') * -1) + ' días.';
          }
        }
        let periodo_ = '';
        switch (elemento.periodo) {
          case '1-month':
            periodo_ = '1 Mes';
            break;
          case '2-month':
            periodo_ = '2 Meses';
            break;
          case '3-month':
            periodo_ = '3 Meses';
            break;
          case '4-month':
            periodo_ = '4 Meses';
            break;
          default:
            periodo_ = '';
            break;
        }
        temporal.push({
          imei: elemento.imei,
          uidUnidad: elemento.uidUnidad,
          alias: elemento.alias,
          // tslint:disable-next-line:max-line-length
          modelo: (elemento.marca == null && elemento.modelo == null && elemento.anio == null) ? ' --- ' : elemento.marca + ' ' + elemento.modelo + ' ' + elemento.anio,
          serie: elemento.serie,
          placas: (elemento.placas == null) ? ' --- ' : elemento.placas,
          consumo: (elemento.consumo == null) ? ' --- ' : elemento.consumo,
          icono: elemento.icono,
          color: elemento.color,
          fechaServicio: (elemento.fechaServicio == null) ? ' --- ' : moment(elemento.fechaServicio).format('DD-MM-YYYY'),
          periodo: (elemento.periodo == null) ? '' : elemento.periodo,
          txtperiodo: (periodo_ === '') ? ' --- ' : periodo_,
          faltan: (elemento.fechaServicio == null) ? '' : 'Por fecha: ' + faltan,
          clase: clase,
          km: (elemento.kmServicio == null) ? ' --- ' : elemento.kmServicio,
          kmActual: 'Procesando...',
          faltanKM: '',
          claseKm: '',
          uidOperador: elemento.uidOperador,
          // tslint:disable-next-line:max-line-length
          operador: (elemento.nombre == null && elemento.paterno == null && elemento.materno == null) ? 'Sin asignación' : elemento.nombre + ' ' + elemento.paterno + ' ' + elemento.materno,
          licencia: (elemento.licencia == null) ? 'Sin asignación' : elemento.licencia,
          uidGeo: elemento.uidGeo,
          nombreGeo: (elemento.nombreGeo == null) ? 'Sin asignación' : elemento.nombreGeo
        });
        // @ts-ignore
        if (elemento.json != null) {
          // @ts-ignore
          this.dispositivo[elemento.imei].geocerca = L.geoJSON(JSON.parse(elemento.json), {});
        }
        this.dispositivo[elemento.imei].visible = true;
        this.dispositivo[elemento.imei].posicion = {};
        // contador personas
        this.dispositivo[elemento.imei].contadorPersonasE = 0;
        this.dispositivo[elemento.imei].contadorPersonasS = 0;
        this.dispositivo[elemento.imei].sensorGasolina = {};
        this.dispositivo[elemento.imei].sensorGasolina.porcentaje = 0;
        this.dispositivo[elemento.imei].sensorGasolina.volumen = 0;
        this.dispositivo[elemento.imei].sensorGasolina.claseFuelSensor = 'danger';
        // @ts-ignore
        if (elemento.estado !== undefined && elemento.estado[0] !== undefined && elemento.estado[0].fecha !== undefined) {
          // @ts-ignore
          const diff = moment().diff(elemento.estado[0].fecha, 'hours');
          // tslint:disable-next-line:curly
          if (diff <= 1) {
            this.dispositivo[elemento.imei].estatus = 'online';
          } else if (diff > 1 && diff <= 24) {
            this.dispositivo[elemento.imei].estatus = 'offline';
          } else {
            this.dispositivo[elemento.imei].estatus = 'error';
          }

          // @ts-ignore
          this.dispositivo[elemento.imei].fechaHoraUltimoReporte = moment(elemento.estado[0].fecha);
          // @ts-ignore
          // tslint:disable-next-line:max-line-length
          this.dispositivo[elemento.imei].fechaHoraUltimoReporteFormato = moment(elemento.estado[0].fecha).format('dddd DD [de] MMMM [de] YYYY, h:mm:ss a');
          // tslint:disable-next-line:max-line-length
          this.dispositivo[elemento.imei].tiempoDesdeUltimoReporte = this.diferenciaTiempo(this.dispositivo[elemento.imei].fechaHoraUltimoReporte, elemento.imei);
          this.dispositivo[elemento.imei].time = setInterval(() => {
            if (this.dispositivo[elemento.imei].fechaHoraUltimoReporte) {
              // tslint:disable-next-line:max-line-length
              this.dispositivo[elemento.imei].tiempoDesdeUltimoReporte = this.diferenciaTiempo(this.dispositivo[elemento.imei].fechaHoraUltimoReporte, elemento.imei);
            }
          }, 60000);
        } else {
          this.dispositivo[elemento.imei].ultimo_reporte = false;
          this.dispositivo[elemento.imei].tiempoDesdeUltimoReporte = 'N/A';
          this.dispositivo[elemento.imei].fechaHoraUltimoReporte = false;
          this.dispositivo[elemento.imei].fechaHoraUltimoReporteFormato = '-';
        }
        // @ts-ignore
        if (elemento.estado !== undefined && elemento.estado[0] !== undefined && elemento.estado[0].ultimas_coordenadas[0] !== undefined) {
          // @ts-ignore
          this.dispositivo[elemento.imei].posicion.Altitude = elemento.estado[0].ultimas_coordenadas[0].trama.Altitude;
          // @ts-ignore
          this.dispositivo[elemento.imei].posicion.Longitude = elemento.estado[0].ultimas_coordenadas[0].trama.Longitude;
          // @ts-ignore
          // tslint:disable-next-line:radix
          this.dispositivo[elemento.imei].posicion.Azimuth = parseInt(elemento.estado[0].ultimas_coordenadas[0].trama.Azimuth);
          // @ts-ignore
          this.dispositivo[elemento.imei].posicion.Latitude = elemento.estado[0].ultimas_coordenadas[0].trama.Latitude;
          // Agregado
          // tslint:disable-next-line:max-line-length
          const icono = (this.dispositivo[elemento.imei].icono == null || this.dispositivo[elemento.imei].icono.length === 0) ? 'default' : this.dispositivo[elemento.imei].icono;
          // tslint:disable-next-line:max-line-length
          const color = (this.dispositivo[elemento.imei].color == null || this.dispositivo[elemento.imei].color.length === 0) ? 'black' : this.dispositivo[elemento.imei].color;

          // Kilometraje
          // @ts-ignore
          if ((elemento.estado[0].ultimas_coordenadas[0].trama.Mileage) !== undefined) {
            const indexUnidad = temporal.map(x => x.imei).indexOf(elemento.imei);
            if (indexUnidad !== -1) {
              if (temporal[indexUnidad].km !== ' --- ') {
                let falta = null;
                const km = parseFloat(temporal[indexUnidad].km);
                // @ts-ignore
                // tslint:disable-next-line:max-line-length
                if (elemento.estado[0].ultimas_coordenadas[0].trama.Mileage >= (km - 200) && elemento.estado[0].ultimas_coordenadas[0].trama.Mileage < km) {
                  temporal[indexUnidad].claseKm = 'table-warning';
                  // @ts-ignore
                  falta = 'Faltan ' + (km - elemento.estado[0].ultimas_coordenadas[0].trama.Mileage).toFixed(2) + ' Km.';
                } else
                  // @ts-ignore
                  if (elemento.estado[0].ultimas_coordenadas[0].trama.Mileage === km) {
                    temporal[indexUnidad].claseKm = 'table-danger';
                    falta = 'Necesita servicio por kilometraje.';
                  } else
                    // @ts-ignore
                    if (elemento.estado[0].ultimas_coordenadas[0].trama.Mileage > km) {
                      temporal[indexUnidad].claseKm = 'table-danger';
                      // @ts-ignore
                      // tslint:disable-next-line:max-line-length
                      falta = 'Necesita servicio por kilometraje. Se ha pasado por  ' + (elemento.estado[0].ultimas_coordenadas[0].trama.Mileage - km).toFixed(2) + ' Km.';
                    } else {
                      // @ts-ignore
                      falta = 'Faltan ' + (km - elemento.estado[0].ultimas_coordenadas[0].trama.Mileage).toFixed(2) + ' Km.';
                    }
                temporal[indexUnidad].faltanKM = (falta == null) ? '' : '\n Por kilometraje: ' + falta;
              }
              // @ts-ignore
              temporal[indexUnidad].kmActual = elemento.estado[0].ultimas_coordenadas[0].trama.Mileage;
            }
            // Agregado
          }

          // Agregado
          const customPopup = '<table><tr><th colspan="2" aling="center">' + this.dispositivo[elemento.imei].alias + '</th></tr></table>';
          // @ts-ignore
          // tslint:disable-next-line:max-line-length
          this.dispositivo[elemento.imei].marker = L.marker([elemento.estado[0].ultimas_coordenadas[0].trama.Latitude, elemento.estado[0].ultimas_coordenadas[0].trama.Longitude],
            {
              rotationOrigin: 'center center'
            })
            .bindPopup(customPopup)
            .on('mouseover', function (e) {
              this.openPopup();
            })
            .on('mouseout', function (e) {
              this.closePopup();
            })
            .setIcon(L.divIcon({
              html: '',
              iconSize: [50, 50],
              // @ts-ignore
              // tslint:disable-next-line:max-line-length
              className: elemento.imei + ' ' + icono + color + ' ' + this.icono(parseInt(elemento.estado[0].ultimas_coordenadas[0].trama.Azimuth))
            }));

          this.dispositivo[elemento.imei].paroDeMotor = false;
          this.dispositivo[elemento.imei].salidaTres = false;

          this.divInformacion = this.dispositivo[elemento.imei];


          this.markers.addLayer(this.dispositivo[elemento.imei].marker);

          if (this.dispositivo[elemento.imei].geocerca !== undefined) {
            // tslint:disable-next-line:max-line-length
            if (leafletPip.pointInLayer([this.dispositivo[elemento.imei].posicion.Latitude, this.dispositivo[elemento.imei].posicion.Longitude], this.dispositivo[elemento.imei].geocerca).length === 0) {
              this.dispositivo[elemento.imei].classGeocerca = 'text-danger';
            } else {
              this.dispositivo[elemento.imei].classGeocerca = '';
            }
          }

        }

        try {
          // @ts-ignore
          this.seteo_valores(elemento.imei, elemento.estado[0].ultimas_coordenadas[0].trama);
          // @ts-ignore
          this.can100(elemento.imei, elemento.estado[0].ultimas_coordenadas[0].trama);
        } catch (error) {

        }

      });
    },
      err => { this.auth.logout(); this.router.navigate(['login']); }
    );
  }




  /**
    * Para girar el icono segun su Azimuth
    * @param grados Azimuth enviado por el gps
  **/
  icono(grados) {
    let className;
    switch (true) {
      case (grados > 349 || grados <= 11): {
        className = 'uno';
        break;
      }
      case (grados > 11 && grados <= 34): {
        className = 'dos';
        break;
      }
      case (grados > 34 && grados <= 56): {
        className = 'tres';
        break;
      }
      case (grados > 56 && grados <= 79): {
        className = 'cuatro';
        break;
      }
      case (grados > 79 && grados <= 101): {
        className = 'cinco';
        break;
      }
      case (grados > 101 && grados <= 124): {
        className = 'seis';
        break;
      }
      case (grados > 124 && grados <= 146): {
        className = 'siete';
        break;
      }
      case (grados > 146 && grados <= 169): {
        className = 'ocho';
        break;
      }
      case (grados > 169 && grados <= 191): {
        className = 'nueve';
        break;
      }
      case (grados > 191 && grados <= 214): {
        className = 'diez';
        break;
      }
      case (grados > 214 && grados <= 236): {
        className = 'once';
        break;
      }
      case (grados > 236 && grados <= 259): {
        className = 'doce';
        break;
      }
      case (grados > 259 && grados <= 281): {
        className = 'trece';
        break;
      }
      case (grados > 281 && grados <= 304): {
        className = 'catorce';
        break;
      }
      case (grados > 304 && grados <= 326): {
        className = 'quince';
        break;
      }
      case (grados > 326 && grados <= 349): {
        className = 'dieciseis';
        break;
      }

    }
    return className;

  }

  /**
    * Pra mostrar el tiempo que lleva sin reportar el gps
    * @param nombre Fecha de ultimo reporte
    * @param imei Identificador de unidad
  **/
  diferenciaTiempo(tiempo, imei) {
    let cantidad;
    const now = moment([]);
    let time;

    if ((cantidad = (now.diff(tiempo, 'years'))) > 0) {
      if (cantidad === 1) {
        time = 'Hace ' + cantidad + ' año.';
      } else {
        time = 'Hace ' + cantidad + ' años.';
      }
    } else if ((cantidad = (now.diff(tiempo, 'months'))) > 0) {
      time = 'Hace ' + cantidad + ' m';
    } else if ((cantidad = (now.diff(tiempo, 'days'))) > 0) {
      this.dispositivo[imei].estatus = 'error';
      time = 'Hace ' + cantidad + ' d';
    } else if ((cantidad = (now.diff(tiempo, 'hours'))) > 0) {
      time = 'Hace ' + cantidad + ' h';
      this.dispositivo[imei].estatus = 'offline';
    } else if ((cantidad = (now.diff(tiempo, 'minutes'))) > 0) {
      this.dispositivo[imei].estatus = 'online';
      time = 'Hace ' + cantidad + ' min';
    } else if ((cantidad = (now.diff(tiempo, 'seconds'))) >= 0) {
      time = 'Hace unos segundos';
    } else {
      time = '-';
    }

    return time;
  }


  // Usuarios
  /**
   * Revisa si hay usuarios tienes permisos para poder
   * asignar o desasignar unidades que puede ver en la plataforma,
   * abre la venta de usuarios
   */
  verUsuarios() {
    if (this.listadoUsuarios.length !== 0) {
      document.getElementById('ventanaUsuarios').classList.add('abrir');
    } else {
      swal('¡Acceso denegado!', 'No tienes los permisos necesarios para acceder.', 'warning');
    }
  }
  /**
   * Cierra la venta de usuarios
   */
  cerrarUsuarios() {
    document.getElementById('ventanaUsuarios').classList.remove('abrir');
  }
  /**
   * Prepara los datos para la asignacion o desasignacion
   * de las unidades que puede ver en la plataforma
   * @param unidadesAsignadas Las que tiene actualmente asignadas
   * @param dropdownList Unidades que s epueden asignar para verlas en la plataforma
   * @param userUID Clave unica del usuario
   */
  modalAsignarUnidad(userUID) {
    this.model = {};
    const indiceUsuario = this.listadoUsuarios.map(x => x.usuarioID).indexOf(userUID);
    const selectedItems = [];
    const unidadesT: Array<any> = [];
    const unidadesAsignadas = [];
    if (this.listadoUsuarios[indiceUsuario].unidadesID != null) {
      this.listadoUsuarios[indiceUsuario].unidadesID.forEach(element => {
        const indiceunidad = this.listadoUnidades.map(x => x.uidUnidad).indexOf(parseInt(element));
        if (indiceunidad !== -1) {
          selectedItems.push({
            item_id: this.listadoUnidades[indiceunidad].uidUnidad,
            item_text: this.listadoUnidades[indiceunidad].alias
          });
          unidadesAsignadas.push(this.listadoUnidades[indiceunidad].alias);
        }
      });
    }
    this.listadoUnidades.forEach(element => {
      unidadesT.push({
        item_id: element.uidUnidad,
        item_text: element.alias
      });
    });
    this.model = {
      nombreU: this.listadoUsuarios[indiceUsuario].nombres + ' ' + this.listadoUsuarios[indiceUsuario].apellidos,
      selectedItems: selectedItems,
      dropdownList: unidadesT,
      dropdownSettings: {
        singleSelection: false,
        idField: 'item_id',
        textField: 'item_text',
        selectAllText: 'Selecionar todos',
        unSelectAllText: 'Deseleccionar todos',
        searchPlaceholderText: 'Buscar..',
        allowSearchFilter: true
      },
      confirmText: '',
      unidadesAsignadas: unidadesAsignadas,
      indiceUsuario: indiceUsuario
    };
    $('#unidadesError').html('');
  }
  /**
   * Prepara los datos para la asignacion o desasignacion
   * de las unidades que puede ver en la plataforma
   * @param unidaes Las unidades a asignar
   * @param userUID Clave unica del usuario
   */
  asignarUnidades() {
  const unidades = [];
  const alias = [];
  let error = '';

  for (let i = 0; i < this.model.selectedItems.length; i++) {
    const element = this.model.selectedItems[i];
    const idx = this.listadoUnidades.findIndex(x => x.uidUnidad === parseInt(element.item_id));
    if (idx !== -1) {
      unidades.push(this.listadoUnidades[idx].uidUnidad);
      alias.push(element.item_text);
    } else {
      error = 'Alguna unidad no es correcta, recargue la página.';
      break;
    }
  }

  if (error !== '') {
    document.getElementById('unidadesError').innerText = error;
    return;
  }

  if (this.model.confirmText !== 'ASIGNAR') {
    document.getElementById('unidadesError').innerText = 'Debe escribir "ASIGNAR" para continuar.';
    return;
  }

  this.usuarios.asignarunidades(unidades, this.listadoUsuarios[this.model.indiceUsuario].usuarioID)
    .toPromise()
    .then(data => {
      if (data['warningCount'] === 0) {
        const usuario = this.listadoUsuarios[this.model.indiceUsuario];
        usuario.unidadesID = unidades.length > 0 ? unidades : null;
        usuario.unidadesAlias = alias.length > 0 ? alias.toString() : 'No hay unidades asignadas';
        $('#modalUsuarioUnidades').modal('hide');
        swal('¡Bien hecho!', 'Se actualizó correctamente.', 'success');
      } else {
        swal('¡Oh no!', 'Ocurrio un error intente nuevamente.', 'error');
      }
    })
    .catch(() => {
      swal('¡Oh no!', 'Error al asignar unidades, intente de nuevo.', 'error');
    });
}

// Habilita botón guardar solo si se escribe correctamente
canGuardar(): boolean {
  return !!this.model
    && Array.isArray(this.model.selectedItems)
    && this.model.selectedItems.length > 0
    && this.model.confirmText === 'ASIGNAR';
}



}
